// extracted by mini-css-extract-plugin
module.exports = {"hidden":"FontIcon_hidden__3ZUlJ"};